import { SetGameInfoSchema } from '@pin/schemas/admin';
import { limit, orderBy, query } from 'firebase/firestore';
import { collectionData } from 'rxfire/firestore';
import { firstValueFrom } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { map, shareReplay, timeout } from 'rxjs/operators';
import * as z from 'zod';
import { withIdToken } from '../firebase/auth';
import { gameInfoCol } from '../firebase/firestore/collections';
import { adminApiUrl } from '../utils/context';
import { HttpError } from '../utils/rxjs.http';

export const gameInfo$ = collectionData(
  query(gameInfoCol, orderBy('createdAt', 'desc'), limit(1))
).pipe(
  map(([game]) => game),
  shareReplay({ bufferSize: 1, refCount: true })
);

export const setGameInfo = (
  data: z.input<typeof SetGameInfoSchema>
): Promise<void> =>
  firstValueFrom(
    withIdToken((token) =>
      fromFetch(`${adminApiUrl}/api/game-info`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(SetGameInfoSchema.parse(data)),
        selector: async (res) => {
          if (!res.ok) {
            throw new HttpError(res);
          }
        },
      }).pipe(timeout(10_000))
    )
  );
